import { GET_DELIVERY } from '../constants/actions/delivery';

export const getDeliveryStart = () => ({ type: GET_DELIVERY.START });

export const getDeliverySuccess = (data) => ({ type: GET_DELIVERY.SUCCESS, payload: data });

export const getDeliveryError = () => ({ type: GET_DELIVERY.ERROR, });
